module.exports = __webpack_public_path__ + "static/media/inetcfg_2302.a1d178aa.ico";